module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f572627b3caef731a440613e133041b2.png";